module.exports = __webpack_public_path__ + "static/media/woman.f2e786d0.svg";